import { getZoneDisplayColor } from '@/pages/Business/pages/LogisticOperator/utils/zoneMapColors';
import L from 'leaflet';
import {
  fixNormalizedZoneGeojson,
  normalizeZoneGeojson,
} from '@/pages/Business/pages/Shippings/utils/zoneGeojson';

export interface AddressMapZone {
  id: string;
  name: string;
  color: string | null;
  geojson: unknown;
}

export const drawAddressMapZones = (
  group: L.LayerGroup,
  zones: AddressMapZone[]
) => {
  group.clearLayers();

  zones.forEach((zone) => {
    const normalized = normalizeZoneGeojson(zone.geojson);
    if (!normalized) return;

    const color = getZoneDisplayColor(zone);

    L.geoJSON(fixNormalizedZoneGeojson(normalized), {
      interactive: false,
      style: {
        color,
        fillColor: color,
        weight: 2.5,
        opacity: 0.9,
        fillOpacity: 0.28,
      },
    }).addTo(group);
  });
};
